import React, { useState, useEffect, useCallback, useRef } from "react";
import useStyles from "./style";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Slide,
  DialogActions,
  Typography,
  Button,
  IconButton,
  Divider,
  Grid,
  MenuItem,
  TextField,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import _ from "lodash";
import { useFormik, useField } from "formik";
import { useDropzone } from "react-dropzone";
import CameraAltOutlinedIcon from "@mui/icons-material/CameraAltOutlined";
import * as yup from "yup";

//Libs
import { showLoader, hideLoader } from "Redux/Loader/actions";
import { showSnackbar } from "Redux/SnackBar/actions";
import { useDispatch } from "react-redux";

//Services
import servicetypeapi from "Services/Servicetype";
import { apiUrl } from "../../../../Constants";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const ServiceUpdate = (props) => {
  const { openDialog, id, handleClose } = props;
  const classes = useStyles();
  const dispatch = useDispatch();
  const [details, setDetails] = useState([]);

  // Max file size
  const maxFileSize = 5242880;
  const formatBytes = (bytes, decimals = 2) => {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
  };
  // File length validator
  const fileLengthValidator = (file) => {
    if (file.size > maxFileSize) {
      alert(`File size is larger than ${formatBytes(maxFileSize)}`);
      return {
        code: "file-too-large",
        message: `File size is larger than ${formatBytes(maxFileSize)}`,
      };
    }
    return null;
  };

   // Dropzone for serviceimage props
   const { getRootProps:rootforserviceimage ,
    getInputProps:inputforserviceimage , 
    open:openforserviceimage } = useDropzone({
noClick: true,
noKeyboard: true,
maxSize: formatBytes(maxFileSize),
maxFiles: 1,
accept: "image/*",
validator: fileLengthValidator,
onDrop: (acceptedFiles) => {
let fileLength = acceptedFiles.map((file) => file.size);
if (acceptedFiles && fileLength < maxFileSize) {
  const file = acceptedFiles[0];

  // Convert file to Base64
  const reader = new FileReader();
  reader.onload = () => {
    const base64String = reader.result;
    formik.setFieldValue("serviceImagefile", file);
    formik.setFieldValue("serviceImage", base64String); // Keep the file for form submission
  };
  reader.onerror = (error) => {
    console.error("Error converting file to Base64:", error);
  };
  reader.readAsDataURL(file); // Convert file to Base64
}
},
});

// Dropzone for descriptionimage props
const {getRootProps:rootfordescimage ,
getInputProps:inputfordescimage , 
open:openfordescimage } = useDropzone({
noClick: true,
noKeyboard: true,
maxSize: formatBytes(maxFileSize),
maxFiles: 1,
accept: "image/*",
validator: fileLengthValidator,
onDrop: (acceptedFiles) => {
let fileLength = acceptedFiles.map((file) => file.size);
if (acceptedFiles && fileLength < maxFileSize) {
const file = acceptedFiles[0];

// Convert file to Base64
const reader = new FileReader();
reader.onload = () => {
  const base64String = reader.result;
  formik.setFieldValue("descriptionImagefile", file);
  formik.setFieldValue("descriptionImage", base64String); // Keep the file for form submissio
};
reader.onerror = (error) => {
  console.error("Error converting file to Base64:", error);
};
reader.readAsDataURL(file); // Convert file to Base64
}
},
});
  // Fetch Passenger Details

  const getDetails = useCallback(() => {
    dispatch(showLoader("Loading please wait..."));
    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.status === 200) {
        //console.log("fetched data--->",res.data);
        setDetails(res?.data?.data);
      } else {
        setDetails(null);
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || "Failed to fetch data",
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
      //console.log("Get member / partner details Api", err);
    };
    servicetypeapi.getServicebyid(id).then(onSuccess, onFailure);
  }, [id]);

  useEffect(() => {
    openDialog && getDetails();
  }, [openDialog]);

  const handleUpdateServicetype = (formValues) => {
    dispatch(showLoader("Loading please wait..."));
    let validatationPass = true;
       //console.log('formValues?.serviceImage-->',formValues?.serviceImage);
    const data = {
      serviceName: formValues?.serviceName,
      serviceImage: formValues?.serviceImagefile,
      serviceDescritpion: formValues?.description,
      description_image: formValues?.descriptionImagefile,
      seatsAvailable: formValues?.seatsAvailable,
    };

    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.status === 200) {
        dispatch(
          showSnackbar({
            message: "Service Details Updated Successfully",
            autoHideDuration: 3000,
            anchorOrigin: {
              vertical: "top",
              horizontal: "right",
            },
            variant: "success",
          })
        );

        //console.log("the response data ", res?.data);
        // setProfileDetails([]);
        formik.resetForm();
        handleClose();
        // getProfileDetails();
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || "Failed to update data",
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
      //console.log("update service details api error", err);
    };

    if (validatationPass) {
      servicetypeapi.updateService(id, { ...data }).then(onSuccess, onFailure);
    }
  };

  // Formik - Set fetched values for master
  useEffect(() => {
    const updateFormValues = async () => {
      if (!_.isEmpty(details)) {
        formik.setFieldValue("serviceName", details?.serviceName);
        formik.setFieldValue("serviceImage", `${apiUrl}${details?.serviceImageLocal}`);
        formik.setFieldValue("serviceImagefile", `${apiUrl}${details?.serviceImageLocal}`);
        formik.setFieldValue("description", details?.serviceDescritpion || details?.serviceName);
        formik.setFieldValue("descriptionImage", `${apiUrl}${details?.description_image_local}`);
        formik.setFieldValue("descriptionImagefile", `${apiUrl}${details?.description_image_local}`);
        formik.setFieldValue("seatsAvailable", details?.seatsAvailable);
      }
      //console.log('formik--->',formik);
    };
    updateFormValues();
  }, [details]);

  // Formik

  const formik = useFormik({
    initialValues: {
      serviceImage:"",
      serviceImagefile:"",
      serviceName: "",
      description: "",
      descriptionImage: "",
      descriptionImagefile: "",
      seatsAvailable:"",
    },
    validationSchema: yup.object({
      serviceName: yup.string().required("Service Name is required").nullable(),
      description: yup.string().required("Description is required").nullable(),
      seatsAvailable: yup.string().required("seatsAvailable is required").nullable(),
      descriptionImage: yup.string().required("Description Image is required").nullable(),
      serviceImage: yup.string().required("Service Image is required").nullable(),
    }),
    enableReinitialize: true,
    onSubmit: handleUpdateServicetype,
  });

  //Tabs

  return (
    <>
<Dialog
open={openDialog}
TransitionComponent={Transition}
keepMounted
onClose={handleClose}
maxWidth={"xl"}
aria-describedby="dialog-box"
className={classes.root}
>
<DialogTitle>
  <section className={classes.dialogTitleContainer}>
    <Typography variant="body1" className={classes.title}>
      Update Service
    </Typography>
    <IconButton aria-label="close" onClick={handleClose}>
      <CloseIcon className={classes.closeIcon} />
    </IconButton>
  </section>
</DialogTitle>
<DialogContent>

<Grid container spacing={2} rowSpacing={3} columnSpacing={4} className={classes.detailsContainer} >

{/* service details feilds */}

<Grid item xs={6} >
<TextField
name="serviceName"
id="serviceName"
label="Service Name"
value={formik?.values?.serviceName}
defaultValue={formik?.values?.serviceName}
onChange={formik.handleChange}
error={
formik?.errors?.serviceName &&
formik?.touched?.serviceName
}
helperText={
formik?.errors?.serviceName &&
formik?.touched?.serviceName &&
formik?.errors?.serviceName
}
fullWidth
variant="outlined"
size="small"
></TextField>
</Grid>

<Grid item xs={6}  >
<TextField
name="description"
id="description"
label="Description"
value={formik?.values?.description}
defaultValue={formik?.values?.description}
onChange={formik.handleChange}
error={
formik?.errors?.description &&
formik?.touched?.description
}
helperText={
formik?.errors?.description &&
formik?.touched?.description &&
formik?.errors?.description
}
fullWidth
variant="outlined"
size="small"
></TextField>
</Grid>

<Grid item xs={6}  >

<h5>Service Image</h5>

<img src={formik?.values?.serviceImage?
  formik?.values?.serviceImage:"/assets/images/logos/no-image.png"
}
alt="avatar"
className={classes.carimages}
/>

<section {...rootforserviceimage()} onClick={openforserviceimage} >
<input {...inputforserviceimage()} />
<CameraAltOutlinedIcon />
</section>

{formik.errors.serviceImage && formik.touched.serviceImage && (
<Typography color="error" variant="caption">
{formik.errors.serviceImage}
</Typography>
)}

</Grid>

<Grid item xs={6}  >

<h5>Description Image</h5>

<img src={formik?.values?.descriptionImage?
  formik?.values?.descriptionImage:"/assets/images/logos/no-image.png"}
alt="avatar"
className={classes.carimages}
/>

<section {...rootfordescimage()} onClick={openfordescimage} >
<input {...inputfordescimage()}/>
<CameraAltOutlinedIcon />
</section>

{formik.errors.descriptionImage && formik.touched.descriptionImage && (
<Typography color="error" variant="caption">
{formik.errors.descriptionImage}
</Typography>
)}

</Grid>

<Grid item xs={12} >
<TextField
name="seatsAvailable"
id="seatsAvailable"
label="Seats Available"
type="number"
inputProps={{
    min: 0
  }}
value={formik?.values?.seatsAvailable}
defaultValue={formik?.values?.seatsAvailable}
onChange={formik.handleChange}
error={
formik?.errors?.seatsAvailable &&
formik?.touched?.seatsAvailable
}
helperText={
formik?.errors?.seatsAvailable &&
formik?.touched?.seatsAvailable &&
formik?.errors?.seatsAvailable
}
fullWidth
variant="outlined"
size="small"
></TextField>
</Grid>

{/* Add service button */}      
<Grid item xs={12}>
<Button variant="contained" onClick={formik?.handleSubmit} className={classes.sbtBtnWrapper}>
Update Service
</Button>
</Grid>

</Grid>

</DialogContent>
<Divider />
<DialogActions>
  <section className={classes.dialogActions}>
    <section className={classes.closeBtn}>
      <Button onClick={handleClose}>Close</Button>
    </section>
  </section>
</DialogActions>
</Dialog>
    </>
  );
};

export default ServiceUpdate;
